import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPackage, FiTool, FiShield, FiTruck } = FiIcons;

const Services = () => {
  const services = [
    {
      icon: FiPackage,
      title: 'Fabric Sourcing & Trading',
      description: 'Quality cotton, silk, wool, and synthetic fabrics supplied in bulk or retail quantities for garment makers, traders, and retailers.',
      features: ['Bulk Quantities', 'Retail Quantities', 'Multiple Fabric Types', 'Fair Pricing']
    },
    {
      icon: FiTool,
      title: 'Apparel & Clothing Manufacturing',
      description: 'T-shirts, garments, and custom apparel manufactured to your design, size, and quantity requirements.',
      features: ['Custom Design', 'Private Label', 'Size Range Flexibility', 'Sample Approval']
    },
    {
      icon: FiShield,
      title: 'Custom & Private Label Work',
      description: 'End-to-end custom manufacturing for brands and businesses who need their own labelled clothing and textile products.',
      features: ['Custom Prints', 'Brand Labelling', 'Design Support', 'Order-based Production']
    },
    {
      icon: FiTruck,
      title: 'Wholesale & Bulk Trading',
      description: 'Reliable textile and apparel trading for wholesalers, retailers, and businesses looking for consistent bulk supply.',
      features: ['Wholesale Rates', 'Flexible Order Sizes', 'Pan-India Delivery', 'Repeat Order Support']
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Complete Clothing & Textile Solutions
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Whether you need fabric supply, ready-made apparel, or custom manufacturing,
            we provide comprehensive clothing, apparel, and textile trading solutions.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -5 }}
              className="bg-gray-50 p-8 rounded-2xl hover:shadow-lg transition-all duration-300 group"
            >
              <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <SafeIcon icon={service.icon} className="w-8 h-8 text-white" />
              </div>

              <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>

              <ul className="space-y-2">
                {service.features.map((feature) => (
                  <li key={feature} className="flex items-center text-sm text-gray-500">
                    <div className="w-1.5 h-1.5 bg-blue-600 rounded-full mr-3"></div>
                    {feature}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;